import { Pipe, PipeTransform } from '@angular/core';
import { ExportStatus } from '../types/export.types';

@Pipe({
  name: 'exportStatusTransform'
})
export class ExportStatusTransformPipe implements PipeTransform {
  transform(value: string): String {
    let exportStatus: ExportStatus = value as ExportStatus;
    switch (exportStatus) {
      case 'Delay':
        return 'Deferred';
      case 'Pending':
        return 'In Progress';
      case 'Waiting':
        return 'In Progress';
      case 'Error':
        return 'Contact NESS Support';
      default:
        return value;
    };
  }
}
